import Cookie from "js-cookie";
import {
  POST_LOGIN_REDIRECT_KEY,
  LOGIN_STORAGE_KEY,
  SIGNUP_STORAGE_KEY,
  CHECKOUT_SUCCESS_REDIRECT_KEY,
  UPGRADE_ON_WEBSITE_KEY,
} from "../consts";
import { isSSR } from "./ssr";

export const setPostLoginRedirect = (path: string) => {
  window.localStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

export const clearPostLoginRedirect = () => {
  window.localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
};

export const getPostLoginRedirect = () => {
  return window.localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
};

export const getEmailFromSessionStorage = () => {
  if (isSSR()) return "";
  return window.sessionStorage.getItem(LOGIN_STORAGE_KEY) ?? "";
};

export const setEmailInSessionStorage = (email: string) => {
  window.sessionStorage.setItem(LOGIN_STORAGE_KEY, email);
};

export const clearEmailFromSessionStorage = () => {
  window.sessionStorage.removeItem(LOGIN_STORAGE_KEY);
};

export const setSignupLocation = (location: string) => {
  window.localStorage.setItem(SIGNUP_STORAGE_KEY, location);
};

export const getSignupLocation = () => {
  return window.localStorage.getItem(SIGNUP_STORAGE_KEY);
};

export const clearSignupLocation = () => {
  window.localStorage.removeItem(SIGNUP_STORAGE_KEY);
};

export const getPostCheckoutRedirect = () => {
  return window.localStorage.getItem(CHECKOUT_SUCCESS_REDIRECT_KEY);
};

export const clearPostCheckoutRedirect = () => {
  window.localStorage.removeItem(CHECKOUT_SUCCESS_REDIRECT_KEY);
};

export const setUpgradedOnWebsite = (userId: string) => {
  const key = `${userId}-${UPGRADE_ON_WEBSITE_KEY}`;
  Cookie.set(key, "true", { expires: 1 });
};
